import { isTruthy } from '@ardoq/common-helpers';
import { getComponentTypesForLegend } from '@ardoq/view-legend';
import type { ComponentTypeForLegend } from '@ardoq/view-legend';
import { ComponentMatrixItem } from '../types';

export const computeLegendComponentTypes = (
  items: ComponentMatrixItem[]
): ComponentTypeForLegend[] =>
  getComponentTypesForLegend(
    items.flatMap(item => [
      item.componentId,
      ...item.address.columnValues.filter(isTruthy),
      ...item.address.rowValues.filter(isTruthy),
    ])
  );
